import BankOfAmerica from '../assets/shared/BankOfAmerica.svg';
import CapitalBank from '../assets/shared/CapitalBank.svg';
import CharlesSchwab from '../assets/shared/CharlesSchwab.svg';
import ChaseBank from '../assets/shared/ChaseBank.svg';
import PncBank from '../assets/shared/PncBank.svg';
import CitiBank from '../assets/shared/CitiBank.svg';
import RegionsBank from '../assets/shared/RegionsBank.svg';
import SunTrust from '../assets/shared/SunTrust.svg';
import BankWorldBlue from '../assets/shared/bankWorldBlue.svg';
import UsBank from '../assets/shared/UsBank.svg';
import UsaBank from '../assets/shared/UsaBank.svg';
import WellsFargo from '../assets/shared/WellsFargo.svg';

const ListOfBanks = [
    { bankIcon: BankOfAmerica, banckName: 'fake' },
    { bankIcon: CapitalBank, banckName: 'fake' },
    { bankIcon: CharlesSchwab, banckName: 'fake' },
    { bankIcon: ChaseBank, banckName: 'fake' },
    { bankIcon: CitiBank, banckName: 'fake' },
    { bankIcon: RegionsBank, banckName: 'fake' },
    { bankIcon: BankWorldBlue, banckName: 'fake' },
    { bankIcon: PncBank, banckName: 'fake' },
    { bankIcon: SunTrust, banckName: 'fake' },
    { bankIcon: UsBank, banckName: 'fake' },
    { bankIcon: UsaBank, banckName: 'fake' },
    { bankIcon: WellsFargo, banckName: 'fake' }
];

export default ListOfBanks;
